import { createRouter, createWebHistory } from 'vue-router';
import WelcomeScreen from '@/components/WelcomeScreen';
import JuryLogin from '../components/JuryLogin.vue';
import JuryProfile from '../components/JuryProfile.vue';
import EvaluationScreen from '../components/EvaluationScreen.vue';
import ResultsScreen from '../components/ResultsScreen.vue';
import JuryResetPassword from '../components/JuryResetPassword.vue';
import store from '../store';

const routes = [
  {
    path: '/',
    name: 'WelcomeScreen',
    component: WelcomeScreen,
  },
  {
    path: '/jury-login',
    name: 'JuryLogin',
    component: JuryLogin,
    meta: { guest: true },
  },
  {
    path: '/evaluation',
    name: 'EvaluationScreen',
    component: EvaluationScreen,
    meta: { requiresAuth: true, requiresScorer: true },
  },
  {
    path: '/results',
    name: 'ResultsScreen',
    component: ResultsScreen,
    meta: { tryAuth: true },
  },
  {
    path: '/jury-profile',
    name: 'JuryProfile',
    component: JuryProfile,
    meta: { requiresAuth: true },
  },
  {
    path: '/jury/reset-password',
    name: 'JuryResetPassword',
    component: JuryResetPassword,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard to protect routes
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  const hasJuryData = !!store.state.jury;

  // Public route that silently tries to restore session (results page)
  if (to.meta.tryAuth && isAuthenticated) {
    try { await store.dispatch('restoreSession'); } catch (e) { /* silent */ }
  }

  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    if (!isAuthenticated) {
      next('/jury-login');
      return;
    }

    // Always refresh session to get latest permissions from server
    try {
      const restored = await store.dispatch('restoreSession');
      if (!restored) {
        next('/jury-login');
        return;
      }
    } catch (error) {
      console.error('Session restoration error:', error);
      next('/jury-login');
      return;
    }

    // Evaluation screen requires scoring permission
    if (to.meta.requiresScorer) {
      const canScore = store.getters.canAddMonthlyData || store.getters.canAddPitchData;
      if (!canScore) {
        next('/results');
        return;
      }
    }
  }

  // Redirect logged-in users away from login page
  if (to.meta.guest && isAuthenticated && store.state.jury) {
    const canScore = store.getters.canAddMonthlyData || store.getters.canAddPitchData;
    next(canScore ? '/evaluation' : '/results');
    return;
  }

  next();
});

export default router;